import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calculator, Settings, History, Users } from 'lucide-react';


const QuickActionsPanel = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      label: 'Calculadora de Lucro',
      description: 'Novo cálculo de rentabilidade',
      icon: Calculator,
      onClick: () => navigate('/profit-calculator'),
      variant: 'default'
    },
    {
      label: 'Configurar Impostos',
      description: 'Ajustar tabelas e alíquotas',
      icon: Settings,
      onClick: () => navigate('/tax-configuration-settings'),
      variant: 'outline'
    },
    {
      label: 'Histórico Completo',
      description: 'Ver todos os cálculos',
      icon: History,
      onClick: () => navigate('/profit-calculation-history'),
      variant: 'outline'
    },
    {
      label: 'Gerenciar Usuários',
      description: 'Administrar acessos',
      icon: Users,
      onClick: () => navigate('/admin'),
      variant: 'outline'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6">
      <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-4">Ações Rápidas</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        {quickActions?.map((action, index) => (
          <button
            key={index}
            onClick={action?.onClick}
            className="flex flex-col items-start gap-2 p-4 bg-muted/50 hover:bg-muted border border-border rounded-lg transition-all hover:shadow-md text-left"
          >
            <div className="p-2 bg-primary/10 rounded-lg">
              <action.icon className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h4 className="font-semibold text-foreground text-sm sm:text-base">{action?.label}</h4>
              <p className="text-xs sm:text-sm text-muted-foreground mt-1">{action?.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;